import { type FC, MouseEventHandler, type ReactNode } from 'react';
import { usePathname } from 'next/navigation';

import routes from '@shared/routes';
import { Container, Flex, Link } from '@shared/ui-kit';

interface Props {
  logo?: ReactNode;
  profile?: ReactNode;
  nav?: ReactNode;
}
const Layout: FC<Props> = (props) => {
  const { logo, profile, nav } = props;
  const pathname = usePathname();

  const onLogoClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (pathname === routes.merchants) {
      e.preventDefault();
    }
  };

  return (
    <Container>
      <Flex
        w="full"
        alignItems="center"
        justifyContent="space-between"
      >
        <Flex
          alignItems="center"
          columnGap="8"
        >
          {logo && (
            <Link
              href={routes.merchants}
              onClick={onLogoClick}
            >
              {logo}
            </Link>
          )}

          {nav}
        </Flex>
        {profile}
      </Flex>
    </Container>
  );
};

export default Layout;
